import React from "react";
import Modal from "react-responsive-modal";
import { Button } from "../../../revvComponents";

import { IMAGE_URLS } from "../../../constants";

const { SHIELD, RECIPIENT_DECLINE, RECIPIENT_THANKS } = IMAGE_URLS;

const copyText = {
  Declined: {
    imageSrc: RECIPIENT_DECLINE,
    heading: "This document has been declined",
    subheading1: "You could leave comments for the sender under Notes.",
    subheadingHighlight: "",
    subheading2: "",
  },
  ThanksForFillingESign: {
    imageSrc: RECIPIENT_THANKS,
    heading: "Thanks for filling this document!",
    subheading1:
      "Once the other signers have filled and submitted this form, you will get notified by email to eSign this document. If you're the only recipient, you can eSign the document immediately.",
    subheadingHighlight: "",
    subheading2: "",
  },
  ThanksForFillingFillAccept: {
    imageSrc: RECIPIENT_THANKS,
    heading: "Thanks for filling this document!",
    subheading1:
      "Once other recipients have filled and submitted this form, you will get notified by email to give your consent by clicking",
    subheadingHighlight: "I accept.",
    subheading2:
      "If you're the only recipient, you can accept the document immediately.",
  },
  AcceptedDocument: {
    imageSrc: RECIPIENT_THANKS,
    heading: "Awesome!",
    subheading1:
      "You have just accepted and given your consent to this document.",
    subheadingHighlight: "",
    subheading2: "",
  },
  ForwardedDocument: {
    imageSrc: RECIPIENT_THANKS,
    heading: "Congratulations!",
    subheading1:
      "An email with the document link has been sent to the added recipients.",
    subheadingHighlight: "",
    subheading2: "",
  },
};

const RecipientThanksDeclinedPopup = ({ onClose, view, band }) => {
  const content = copyText[view];
  if (band && band === "SENT_FOR_SIGN") {
    return null;
  }
  return (
    <Modal
      classNames={{
        modal: "recipientdocinfopopup-modal",
        closeButton: "modal-close-btn-mobile-view",
      }}
      open
      onClose={onClose}
      center
      closeOnOverlayClick={false}>
      <div className="recipientdocinfopopup-container">
        {/* ------ Recipient document info header(gif, recipient title and send info) section ------ */}
        <div className="recipientdocinfopopup-header">
          <div className="recipientdocinfopopup-img-wrapper">
            <img
              src={content.imageSrc}
              alt="form-mode-check"
              className="recipientdocinfopopup-img"
            />
          </div>
          <div className="recipientdocinfopopup-recipient-title">
            {content.heading}
          </div>
          <div className="recipientdocinfopopup-sender-info unfilled-info">
            {content.subheading1}{" "}
            <strong>
              <i>{content.subheadingHighlight}</i>{" "}
            </strong>{" "}
            {content.subheading2}
          </div>
        </div>

        {/* ------ Recipient document footer info section  ------ */}
        <div className="recipientdocinfopopup-footer-info recipient-footer-info">
          <br />
          <span className="recipientdocinfopopup-footer-desc">
            This document was created and shared with you through Revv, a
            document workflow automation platform for business paperwork.
          </span>
          <br />
          <br />
          <img
            src={SHIELD}
            data-test="recipientdocinfopopup-footer-info-img"
            className="recipientdocinfopopup-footer-infoimg"
            alt="Revv"
          />
          <span className="recipientdocinfopopup-footer-desc">
            Join the 6000+ companies that trust and use Revv to create, share
            and sign documents.
          </span>
        </div>

        <div className="unfilled-form-popup-footer recipient-single-btn">
          <Button
            data-test="submit-anyway-button"
            className="recipient-declined-btn"
            onClick={() => {
              window.open(
                "https://www.revv.so/",
                "_blank", // <- This is what makes it open in a new window.
              );
            }}
            onKeyPress={() => {}}>
            Try Revv for free
          </Button>
        </div>
      </div>
    </Modal>
  );
};
export default RecipientThanksDeclinedPopup;
